import { createFileRoute, Link, Outlet, useNavigate, useLocation } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/cuenta")({
  head: () => ({ meta: [{ title: "Mi cuenta — Truck Company Center" }, { name: "robots", content: "noindex" }] }),
  component: CuentaLayout,
});

function CuentaLayout() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const sub = supabase.auth.onAuthStateChange((_e, session) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });
    supabase.auth.getSession().then(({ data }) => {
      setUser(data.session?.user ?? null);
      setLoading(false);
    });
    return () => { sub.data.subscription.unsubscribe(); };
  }, []);

  // Public auth subroutes don't need the wrapper. Use router's location (SSR-safe) to avoid hydration mismatch.
  const location = useLocation();
  const isPublicAuth = ["/cuenta/login", "/cuenta/registro", "/cuenta/recuperar", "/cuenta/reset-password"].includes(location.pathname);

  if (isPublicAuth) return <Outlet />;

  if (loading) return <div className="mx-auto max-w-2xl px-4 py-20 text-muted-foreground">Cargando...</div>;

  if (!user) {
    return (
      <div className="mx-auto max-w-md px-4 py-16 md:px-6 text-center">
        <h1 className="font-display text-2xl font-semibold text-foreground">Inicia sesión para ver tu cuenta</h1>
        <p className="mt-2 text-sm text-muted-foreground">Accede para ver tus pedidos y formularios.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/cuenta/login"><Button className="bg-primary text-primary-foreground hover:bg-primary/90">Iniciar sesión</Button></Link>
          <Link to="/cuenta/registro"><Button variant="outline" className="border-hairline">Crear cuenta</Button></Link>
        </div>
      </div>
    );
  }

  async function logout() {
    await supabase.auth.signOut();
    nav({ to: "/" });
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 md:px-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-label-accent">Mi cuenta</div>
          <h1 className="mt-1 font-display text-2xl font-semibold text-foreground">{user.email}</h1>
        </div>
        <Button onClick={logout} variant="outline" size="sm" className="border-hairline">Cerrar sesión</Button>
      </div>
      <div className="mt-8"><Outlet /></div>
    </div>
  );
}
